module.exports = __webpack_public_path__ + "static/media/whiteClose.184e0df3.svg";